__turbopack_context__.v({
  "projects-awards": "ProjectsAwwards-module-sass-module__4hNVFW__projects-awards",
  "projects-awards-item": "ProjectsAwwards-module-sass-module__4hNVFW__projects-awards-item",
  "projects-awards-item__award": "ProjectsAwwards-module-sass-module__4hNVFW__projects-awards-item__award",
  "projects-awards__title": "ProjectsAwwards-module-sass-module__4hNVFW__projects-awards__title",
});
